import React from 'react';
import classnames from 'classnames';
import styles from './ProgressIndicator.mod.scss';

export default function ProgressIndicator({ steps }) {
  return steps ? (
    <ol className={styles.container}>
      <ProgressStep state={steps.where}>Where</ProgressStep>
      <ProgressStep state={steps.when}>When</ProgressStep>
      <ProgressStep state={steps.confirm}>Confirm</ProgressStep>
    </ol>
  ) : (
    <div className={styles.emptyContainer} />
  );
}

function ProgressStep({ state = 'default', children }) {
  return (
    <li
      className={classnames(styles.step, {
        [styles.inactiveStep]: state === 'default',
        [styles.activeStep]: state === 'active',
        [styles.completedStep]: state === 'completed'
      })}
    >
      {children}
    </li>
  );
}
